<template>
  <div class="d-flex flex-column align-items-start px-1 py-1 w-100 chart-wrapper widget">
    <slot name="title">
      <h5
        v-if="title"
        class="heading text-heavy mb-0 pl-1"
      >
        {{ title }}
      </h5>
    </slot>
    <div class="position-relative w-100 flex-fill">
      <div
        v-if="loading"
        class="loadingWrapper"
      >
        <b-spinner />
      </div>
      <template v-else>
        <donut-chart-simplified
          :key="data.length"
          name="Jobs"
          :data="data"
          height="370"
        />
        <div
          v-if="isEmpty"
          class="empty"
        >
          <p>No data available</p>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import DonutChartSimplified from '@/components/charts/donut-chart/DonutChartSimplified.vue'

export default {
  name: 'DonutWidget',
  components: {
    DonutChartSimplified,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: null,
    },
  },
  computed: {
    isEmpty() { return !this.data.some(el => el.count > 0) },
  },
}
</script>

<style lang="scss" scoped>
.empty {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
